<template>
  <div>
    <table id="table_budgetaire">
      <tr>
        <th class="th_table_budgetaire head title-weight" colspan="2"
            :class="value.class">
          <p class="is-size-6 has-text-white has-text-weight-bold"> {{value.title}} </p>
          <p class="has-text-white is-size-14px"
            v-if="value.data.dateDebut && value.data.dateFin">
            {{`Du ${formatDate(value.data.dateDebut)} au ${formatDate(value.data.dateFin)}`}}
          </p>
        </th>
      </tr>
      <tr v-for="(column, icol) in columns" :key="icol">
        <th class="th_table_budgetaire has-text-grid-1 is-size-7 has-text-weight-bold has-text-right half_width">
          {{column.title}}
        </th>
        <td :class="`td_table_budgetaire is-size-14px half_width ${column.class}`">
          {{formatNombre(value.data[column.propriety])}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { formatNombre, formatDate } from '@/services/general/general';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  props: {
    data: Object,
    type: String,
  },
  data() {
    return {
      typeProrata: 'prorata',
    };
  },
  computed: {
    ...Recommandation.mapGetters({
      societe: 'societe',
    }),
    columns() {
      let columns = [
        {
          title: 'Budget Brut HT',
          propriety: 'prixBrutNegocie',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'Budget Net HT',
          propriety: 'prixNet',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'TLPE',
          propriety: 'tlpe',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'Honoraires HT',
          propriety: 'honoraires',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'Frais Techniques HT',
          propriety: 'fraisTechnique',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'Total',
          propriety: 'prixTotal',
          class: 'has-text-right has-text-weight-bold has-text-grid-1',
        },
      ];
      return columns;
    },
    value() {
      if (this.type === 'prorata') return {
        data: this.data.budgetProrata,
        class: 'has-background-grid-5',
        title: 'Budget Prorata',
      };
      return {
        data: this.data.budgetAnnuel,
        class: 'has-background-info',
        title: 'Budget Annuel par an',
      };
    },
  },
  methods: {
    formatNombre(val) {
      return formatNombre(val);
    },
    formatDate(date) {
      return formatDate(date);
    },
  },
}
</script>

<style>

</style>